<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          //.profile-page__header
            .profile-page__title
              h1.title Квоты
          .profile-page__tabs
            tab-nav(
            v-bind:tabNavData="tabNavData"
            )
          .profile-page__body
            .profile__table-filter
              .simple-select-form
                .simple-select-form__button Тематическая
                //.simple-select-form__list
                  ul
                    li Тематическая
                    li Специализированная

            .profile__table
              vue-custom-scrollbar(
              class="table-wrapper"
                :settings="settings"
              )
                table.table-inner
                  thead
                    tr.table__row
                      th.table__cell
                        .table__cell-content Квота
                      th.table__cell
                        .table__cell-content Кол-во человек
                      th.table__cell
                        .table__cell-content Цена
                      th.table__cell
                        .table__cell-content Организация
                      th.table__cell
                        .table__cell-content Корпус
                      th.table__cell
                  tbody.table__body
                    tr.table__row
                      td.table__cell
                        .table__cell-content Гимнасты
                      td.table__cell
                        .table__cell-content 15
                      td.table__cell
                        .table__cell-content 5000
                      td.table__cell
                        .table__cell-content АССШ 45
                      td.table__cell
                        .table__cell-content №4, №5, №6
                      td.table__cell
                    tr.table__row
                      td.table__cell
                        .table__cell-content Гимнасты
                      td.table__cell
                        .table__cell-content 15
                      td.table__cell
                        .table__cell-content 5000
                      td.table__cell
                        .table__cell-content АССШ 45
                      td.table__cell
                        .table__cell-content №7
                      td.table__cell
              .form__elem.form__elem--align-right.form__elem_full
                router-link.button.button_paint-main--transparent(
                to="/pages/director/shift/quota/create"
                )
                  .button__text Добавить квоту
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import DirectorTable from "../components/director-table.vue";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import VueCustomScrollbar from "../../../../../node_modules/vue-custom-scrollbar/src/vue-scrollbar.vue";

export default {
  name: "DirectorShiftsQuota",
  components: {
    VueCustomScrollbar,
    TabNav,
    DirectorTable,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      },
      tabNavData: {
        tabs: [
          {
            path: "/pages/director/shift/create",
            text: "Общая информация"
          },
          {
            path: "/pages/director/shift/quota",
            text: "Квоты"
          },
          {
            path: "/pages/director/shift/about",
            text: "Описание"
          },
          {
            path: "/pages/director/shift/program",
            text: "Программа"
          },
          {
            path: "/pages/director/shift/schedule",
            text: "Распорядок дня"
          },
          {
            path: "/pages/director/shift/teachers",
            text: "Педагоги"
          },
          {
            path: "/pages/director/shift/contacts",
            text: "Контакты"
          }
        ]
      }
    };
  }
};
</script>
